import { C_LEGAL_DOCUMENTS } from "../../constants/types";
import { LegalCategories } from "./objects";

export const SUB_CATEGORY_CONFIG = {
  [C_LEGAL_DOCUMENTS]: { label: "Legal category", getOptions: LegalCategories },
  /*  [C_TRADING_HOURS]: {
    label: "Trading hours type",
    getOptions: TradingHoursTypes,
  }, */
};

export const requiresSubCategory = (category) =>
  category in SUB_CATEGORY_CONFIG;
